import { render, staticRenderFns } from "./Form05.vue?vue&type=template&id=52ed8d72&scoped=true&"
import script from "./Form05.vue?vue&type=script&lang=js&"
export * from "./Form05.vue?vue&type=script&lang=js&"
import style0 from "./Form05.vue?vue&type=style&index=0&id=52ed8d72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed8d72",
  null
  
)

export default component.exports